import CONFIG from "config/config";

// PAD-33097: /platform/me is a REST route. oppizi-api REST auth reads `x-api-key`
// (and only recently a Bearer header); when it saw no token it fell through to the
// ambient `.oppizi.com` oppizi-auth cookie, which can belong to a different user on
// a shared-domain environment. So: always send the key the REST layer reads, and
// never send cookies (default `credentials: "same-origin"` sends none cross-origin).
export const meUrl = (): string => `${CONFIG.API_BASE_URL}/me`;

export const meRequestInit = (apiKey: string): RequestInit => ({
  method: "GET",
  headers: { "x-api-key": apiKey },
});
